// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ParentLookupModel {
    static getAttributeTypeMap() {
        return ParentLookupModel.attributeTypeMap;
    }
}
ParentLookupModel.discriminator = undefined;
ParentLookupModel.additionalProperties = false;
ParentLookupModel.attributeTypeMap = [
    {
        "name": "parentId",
        "baseName": "parentId",
        "type": "number"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "code",
        "baseName": "code",
        "type": "string"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
];
//# sourceMappingURL=parentLookupModel.js.map